import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DirectEntryService {
  constructor(private apiService: ApiService) {}

  getDirectEntries(params?: any): Observable<any> {
    return this.apiService.get('direct-entries', params);
  }

  getDirectEntry(id: number): Observable<any> {
    return this.apiService.get(`direct-entries/${id}`);
  }

  createDirectEntry(data: any): Observable<any> {
    return this.apiService.post('direct-entries', data);
  }

  deleteDirectEntry(id: number): Observable<any> {
    return this.apiService.delete(`direct-entries/${id}`);
  }

  updateDirectEntry(id: number, data: any): Observable<any> {
    return this.apiService.update(`direct-entries/${id}`, data);
  }
}
